import { render, staticRenderFns } from "./BlockAdditionalInformation.vue?vue&type=template&id=f0284ec8&"
import script from "./BlockAdditionalInformation.vue?vue&type=script&lang=js&"
export * from "./BlockAdditionalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports